// extracted by mini-css-extract-plugin
export default {"ingestionContainer":"Ingestion_ingestionContainer__x6jje","ingestionContainerRow":"Ingestion_ingestionContainerRow__VIhVV"};